import { uniqueId } from "lodash-es";
import type { Group, TrackType } from "./Base";
import { getTextRect } from "@/utils/canvasUtil";
import { ImgClip, OffscreenSprite } from "@webav/av-cliper";
import { UnitFrame2μs } from "@/stores/clip/data/trackConfig";

export interface TextMaterial {
  id: string;
  content?: string;
  fill?: string;
  stroke?: string;
  fontSize?: number;
  fontFamily?: string;
  backgroundColor?: string;
  name?: string;
  angle?: number;
}

export class TextGroup implements Group {
  id: string;
  content?: string;
  fill?: string;
  stroke?: string;
  fontSize?: number;
  fontFamily?: string;
  backgroundColor?: string;
  name: string;
  materials: TextMaterial[];
  activeSourceIndex: number;
  frameCount: number;
  angle: number;
  start: number;
  end: any;
  offsetL: number;
  offsetR: number;
  constructor(
    materials: TextMaterial[],
    options: { start?: number; frameCount?: number }
  ) {
    // 设置ID
    this.id = uniqueId();

    this.materials = materials;
    this.name = "文本框";
    // 设置轨道信息
    this.frameCount = options.frameCount ?? 30 * 5;
    this.start = options.start ?? 0;
    this.end = this.start + this.frameCount;
  }

  type: TrackType = "text";
  centerX = 0;
  centerY = 0;
  scale = 100;
  width = 0;
  height = 0;
}
